import TileEpisode from './TileEpisode'

export default TileEpisode
// eslint-disable-next-line import/export
export * from './TileEpisode'
